var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row mb-3 header-edit" }, [
    _c(
      "div",
      {
        staticClass:
          "col-12 col-lg-11 col-xl-11 col-md-11 pr-0 fees-percentages-wrapper"
      },
      [
        _c(
          "div",
          {
            staticClass:
              "fees-percentages-orange position-relative flex-column flex-lg-row flex-xl-row flex-md-row"
          },
          [
            _c(
              "div",
              { staticClass: "flex", class: _vm.jobId ? "col-5" : "col-8" },
              [
                _c("span", {
                  staticClass: "mod-icon-weight d-inline-block mr-3"
                }),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "Should cluster fee and percentages be changed for this move?"
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { class: _vm.jobId ? "col-2" : "col-4" }, [
              _vm.enabled
                ? _c(
                    "p",
                    {
                      class: _vm.loading ? "disabled" : "",
                      on: {
                        click: function($event) {
                          !_vm.loading && _vm.toggleChangeFeesPercentages()
                        }
                      }
                    },
                    [
                      _c("span", [_vm._v("No")]),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "switch",
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                            }
                          }
                        },
                        [
                          _c("input", {
                            attrs: { type: "checkbox" },
                            domProps: { checked: _vm.data.fee_change }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "check-slider round" })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        { class: _vm.data.fee_change ? "yes-active" : "" },
                        [_vm._v("Yes")]
                      )
                    ]
                  )
                : _vm.leadId
                  ? _c("p", [
                      _vm._v(
                        "\n          This lead has already been booked, please make adjustments on job.\n        "
                      )
                    ])
                  : _vm._e()
            ]),
            _vm._v(" "),
            _vm.jobId
              ? _c("div", { staticClass: "col-5 inputs" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.data.fee_change,
                          expression: "data.fee_change"
                        }
                      ],
                      staticClass: "row"
                    },
                    [
                      _c("div", { staticClass: "col-4" }, [
                        _c(
                          "div",
                          {
                            staticClass: "select-wrap amount-wrap",
                            class: !_vm.editing ? "border-0" : ""
                          },
                          [
                            _c("label", [_vm._v("Cluster fee")]),
                            _vm._v(" "),
                            _c("span", { staticClass: "dollar" }, [
                              _vm._v("$")
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.clusterFeeValue,
                                  expression: "clusterFeeValue"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: { type: "text", disabled: !_vm.editing },
                              domProps: { value: _vm.clusterFeeValue },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.clusterFeeValue = $event.target.value
                                }
                              }
                            })
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-4" }, [
                        _c(
                          "div",
                          {
                            staticClass: "select-wrap amount-wrap",
                            class: !_vm.editing ? "border-0" : ""
                          },
                          [
                            _c("label", [_vm._v("Cluster %")]),
                            _vm._v(" "),
                            _c("span", { staticClass: "percent" }, [
                              _vm._v("%")
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.clusterPercentValue,
                                  expression: "clusterPercentValue"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: { type: "text", disabled: !_vm.editing },
                              domProps: { value: _vm.clusterPercentValue },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.clusterPercentValue = $event.target.value
                                }
                              }
                            })
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-4" }, [
                        !_vm.editing
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-primary",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    _vm.editing = true
                                  }
                                }
                              },
                              [_vm._v("\n              Edit\n            ")]
                            )
                          : _c(
                              "button",
                              {
                                staticClass: "btn btn-primary",
                                attrs: { type: "button" },
                                on: { click: _vm.saveFeesPercentages }
                              },
                              [_vm._v("\n              Save\n            ")]
                            )
                      ])
                    ]
                  )
                ])
              : _vm._e()
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3b6a992c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b6a992c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeesPercentages.vue
// module id = null
// module chunks = 